export default {
  namespaced: true,
  state: {
    messages: [],
  },
  mutations: {
    addMessage: (state, { text = '', type = 'success', }) => {
      if (state.messages.filter((message) => message.text === text && message.type === type).length > 0) {
        return
      }

      const max = 5
      if (state.messages.length > max - 1) return
      const typesMessage = ['success', 'warning', 'info', 'error',]
      state.messages = [
        ...state.messages,
        {
          id: state.messages.reduce((acc, message) => (acc > message.id ? acc : message.id) + 1, 0),
          type: typesMessage.includes(type) ? type : 'success',
          text,
        },
      ]
    },
    deleteMessage: (state, id) => {
      state.messages = state.messages.filter((message) => message.id !== id)
    },
    deleteAll: (state) => {
      state.messages = []
    },
  },
  getters: {
    messages: (state) => {
      return state.messages
    },
  },
}
